export default __webpack_public_path__ + "images/patientEducationSVG3.394dad53296225cda648da15b7e866f7.svg";